import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { QuantityGetDto } from 'svila-common';

import BorderlessButton from '../../../../components/common/forms/Button/BorderlessButton';
import { Colors } from '../../../../scss/common/style';
import MovementBox from './MovementBox';
import { ROLES, WAREHOUSE_MOVEMENT_CONDITION_TYPES, WAREHOUSE_MOVEMENT_STATUS_TYPES } from '~/src/utils/constants';

import sliderHorizontalIcon from '../../../../static/img/slidersHorizontal.svg';
import swap from '../../../../static/img/swap.svg';
import fileMinus from '../../../../static/img/fileMinus.svg';
import RolesDependent from '~/src/components/common/RolesDependent';

const handleColor = (status: string): string => {
  if (status === 'Waiting') {
    return '#0F6DF9';
  } else if (status === WAREHOUSE_MOVEMENT_STATUS_TYPES.LABELLING.value) {
    return '#EFBB03';
  } else if (status === WAREHOUSE_MOVEMENT_STATUS_TYPES.CONSOLIDATION.value) {
    return '#EF7D00';
  } else if (status === WAREHOUSE_MOVEMENT_STATUS_TYPES.READY.value) {
    return '#05B40C';
  } else if (status === WAREHOUSE_MOVEMENT_CONDITION_TYPES.MISSING.value) {
    return '#e0e0e0';
  } else {
    return Colors.veryLightBlue;
  }
};

interface Props {
  item: QuantityGetDto;
}

export default function StockComponent({ item }: Props): JSX.Element {
  const history = useHistory();
  return (
    <>
      <StyledRow
        status={item.condition === WAREHOUSE_MOVEMENT_CONDITION_TYPES.MISSING.value ? item.condition : item.status}
      >
        <MovementBox item={item}>
          <RolesDependent
            roles={[
              ROLES.ADMIN,
              ROLES.SUPER_ADMIN,
              ROLES.WAREHOUSE_ADMIN,
              ROLES.WAREHOUSE,
              ROLES.OFFICE,
              ROLES.SALES,
              ROLES.DATABASE_ADMIN,
              ROLES.SVILA_CLIENT_ADMIN,
            ]}
          >
            <StyledCol>
              <BorderlessButton
                icon={sliderHorizontalIcon}
                onClick={(): void => {
                  history.push({
                    pathname: `/inventory/add-from-template/${item.product.genericProductId}`,
                    state: { item },
                  });
                }}
                title="Add"
              />
              <BorderlessButton
                icon={sliderHorizontalIcon}
                onClick={(): void => {
                  history.push({
                    pathname: `/inventory/adjustment/${item.product.genericProductId}`,
                    state: { item, type: 'with' },
                  });
                }}
                title="Adjust With"
              />
              <BorderlessButton
                icon={sliderHorizontalIcon}
                onClick={(): void => {
                  history.push({
                    pathname: `/inventory/adjustment/${item.product.genericProductId}`,
                    state: { item, type: 'to' },
                  });
                }}
                title="Adjust To"
              />
              <BorderlessButton
                icon={swap}
                onClick={(): void => {
                  history.push({
                    pathname: `/inventory/split/${item.product.genericProductId}`,
                    state: { item },
                  });
                }}
                title="Change"
              />
              <BorderlessButton
                icon={fileMinus}
                onClick={(): void => {
                  history.push({
                    pathname: `/inventory/remove/${item.product.genericProductId}`,
                    state: { item },
                  });
                }}
                title="Remove"
              />
            </StyledCol>
          </RolesDependent>
        </MovementBox>
      </StyledRow>
    </>
  );
}

const StyledRow = styled.div`
  position: relative;
  display: flex;
  margin: 10px;
  padding: 0;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  border-radius: 2px solid #eeeeee;
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    content: '';
    width: 33px;
    background: ${(props): void => {
    return handleColor(props.status);
  }};
  }
`;

const StyledCol = styled.div`
  height: 100%;
  padding: 10px 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background: #fbfbfb;

  div {
    display: flex;
    justify-content: center;
  }
`;
